module.exports = __webpack_public_path__ + "img/background-4-1-mb.4d57ee48.jpg";